import React from 'react';
import PropTypes from 'prop-types';
import isNil from 'lodash/isNil';
import CenteredLoader from 'app/components/CenteredLoader';
import PlaybookTransformationErrors from './PlaybookTransformationErrors';
import { AceCodeEditor } from '@ion/components';
import { useTrackPage } from '@ion/api';

export default function PlaybookTransformationOutput({ loading, outputEvent, outputErrors, trackingEventName }) {
  useTrackPage(trackingEventName);

  if (loading) {
    return <CenteredLoader />;
  }

  if (outputErrors) {
    return <PlaybookTransformationErrors outputErrors={outputErrors} />;
  }

  if (isNil(outputEvent)) {
    return null;
  }

  const value = JSON.stringify(outputEvent, null, 2);

  return <AceCodeEditor foldable name="outputEvent" lang="json" rows={30} value={value} readOnly />;
}

PlaybookTransformationOutput.propTypes = {
  loading: PropTypes.bool.isRequired,
  outputEvent: PropTypes.object,
  outputErrors: PropTypes.array,
  trackingEventName: PropTypes.string.isRequired,
};
